export const capitalizeFirst = str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  Date.prototype.isValid = function () {
    // An invalid date object returns NaN for getTime() and NaN is the only
    // object not strictly equal to itself.
    return this.getTime() === this.getTime();
}; 